// Note: this tokenizer is synchronized with the one used by the lint rule
// (src/rules/navigation/navigation-routes.js). Please keep them in sync!
import { shallowMemoize } from '@sail/utils';
const SPLIT_REGEXP = /\{(:[^/{}()]+(\(.*?\))?|[^:/{}]+|\/)+\}[?!]?|:[^/{}()]+(\(.*?\))?[?!]?|[^:/{}]+/g;
function getMetaInfo(group) {
    const parts = group.match(/(:([^(/{})]+)(\(.*\))?(\??))/);
    if (!parts) {
        throw new Error(`Invalid section found: ${group}`);
    }
    return {
        id: parts[2] + parts[4],
        idAndPattern: parts[1],
        isOptional: /[?!*]$/.test(group),
        isRepeated: /[+*]$/.test(group),
        pattern: parts[3] ? new RegExp(`^${parts[3]}$`) : undefined
    };
}
export default shallowMemoize(function tokenizePath(path) {
    return (path.match(SPLIT_REGEXP) || []).map((group)=>{
        switch(group.charAt(0)){
            case '{':
                return [
                    group.replace(/^\{\/?|\}[?!]?$/g, ''),
                    getMetaInfo(group)
                ];
            case ':':
                return [
                    group,
                    getMetaInfo(group)
                ];
            default:
                return [
                    group,
                    undefined
                ];
        }
    });
});

//# sourceMappingURL=tokenizePath.js.map